import Navigation from "@/components/Navigation"
import * as missions from "@/store/missions/asyncActions"
import { AppState } from "@/store/reducers"
import * as user from "@/store/user/asyncActions"
import classNames from "classnames"
import { useRouter } from "next/router"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import Icons from "../Icon"
import Logo from "../Logo"
import menus from "./data.json"
import style from "./style.scss"

interface SideBarProps {
  className?: string
  open: boolean
  allMissionCount: number | null
  onClose: () => void
  signOut: () => Promise<void>
  getAllMissions: () => Promise<void>
}

const SideBar: React.SFC<Readonly<SideBarProps>> = (props) => {
  const router = useRouter()

  useEffect(() => {
    props.getAllMissions()
  }, [])

  const handleSignOut = () => {
    props.signOut()
    router.push("/login")
  }

  return (
    <div
      className={classNames(props.className, style.sideBar, {
        [style["sideBar--open"]]: props.open
      })}
    >
      <button className={style.closeButton} onClick={props.onClose}>
        <Icons.Cross />
      </button>

      <Logo className={style.logo} />

      <Navigation
        className={style.navigation}
        items={menus.primaryNavigation}
        newMissionCount={props.allMissionCount}
      />

      <div className={style.signOut}>
        <button onClick={handleSignOut} className={style.signOutButton}>
          <Icons.SignOut className={style.signOutIcon} />
          <span className={style.signOutLabel}>Sign out</span>
        </button>
      </div>
    </div>
  )
}

export default connect(
  (state: AppState) => ({
    allMissionCount:
      state.missions.allMissions &&
      state.missions.allMissions.filter(
        (i) => !i.isComplete() && !i.isUnavailable()
      ).length
  }),
  (dispatch: any) => ({
    signOut: () => dispatch(user.logout()) as Promise<void>,
    getAllMissions: () => dispatch(missions.getAllMissions()) as Promise<void>
  })
)(SideBar)
